import Vue from "vue";
import Router from "vue-router";
import homePage from "@/components/pages/homePage.vue";
import cinemas from "@/components/pages/cinemas";
import cinemaDetails from "@/components/pages/cinemaDetails";
import movies from "@/components/pages/movies";
import userProfile from "@/components/pages/userProfile";
import foodAndDrinks from "@/components/pages/foodAndDrinks";
import onlyFndCheckout from "@/components/pages/onlyFndCheckout";
import finalTicket from "@/components/pages/finalTicket";
import onlyFndFinalTicket from "@/components/pages/onlyFndFinalTicket";
import offersAndPromotions from "@/components/pages/offersAndPromotions";
import advertiseWithUs from "@/components/pages/advertiseWithUs";
import page404 from "@/components/pages/404";

import aboutUs from "@/components/pages/aboutUs";
import contactUs from "@/components/pages/contactUs";
import investors from "@/components/pages/investors";
import termsAndConditions from "@/components/pages/termsAndConditions";
import refundsAndCancellation from "@/components/pages/refundsAndCancellation";
import LifeMirajCinemas from "@/components/pages/LifeMirajCinemas";
import offers from '@/components/pages/offers';
import offerDetail from '@/components/pages/offerDetail';

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home Page",
      meta: {
        title: "Miraj Cinemas"
      },
      component: homePage
    },
    {
      path: "/cinemas",
      name: "Cinemas",
      meta: {
        title: "Cinemas"
      },
      component: cinemas
    },
    {
      path: "/cinema-details/:cinema_code",
      name: "Cinema Details",
      // meta: {
      //     title: "Cinemas"
      // },
      component: cinemaDetails
    },
    {
      path: "/movies",
      name: "Movies",
      component: movies
    },
    {
      path: "/food-and-drinks/:cinema_code",
      name: "Food And Drinks",
      component: onlyFndCheckout
    },
    {
      path: "/final-ticket/:transaction_id",
      name: "Final Ticket",
      component: finalTicket
    },
    {
      path: "/fnd-final-ticket/:transaction_id",
      name: "Only Fnd Final Ticket",
      component: onlyFndFinalTicket
    },
    {
      path: "/offers",
      name: "Offers",
      component: offers
    },
    {
      path: "/offer-detail/:offer_id",
      name: "Offer Detail",
      component: offerDetail
    },
    {
      path: "/offers-and-promotions",
      name: "Offers And Promotions",
      component: offersAndPromotions
    },
    {
      path: "/advertise-with-us",
      name: "Advertise With Us",
      component: advertiseWithUs
    },
    {
      path: "/userProfile/:component_name",
      name: "User Profile",
      component: userProfile
    },
    {
      path: "/movie-details/:movie_code",
      name: "Movie Details",
      component: () => import("@/components/pages/movieDetails")
    },
    {
      path: "/seat-layout/:session_id/:cinema_code",
      name: "Seat Layout",
      component: () => import("@/components/pages/seatLayout")
    },
    {
      path: "/fnd-checkout",
      name: "Food and Drinks Checkout",
      component: () => import("@/components/pages/fndCheckout")
    },
    // {
    //   path: "/only-fnd-checkout",
    //   name: "Only Food and Drinks Checkout",
    //   component: () => import("@/components/pages/onlyFndCheckout")
    // },
    {
      path: "/summary",
      name: "Booking Summary",
      component: () => import("@/components/pages/summary")
    },
    // {
    //   path: "/careers",
    //   name: "Careers",
    //   component: () => import("@/components/pages/careers")
    // },
    {
      path: "/careers-form/:job_id",
      name: "Careers Form",
      component: () => import("@/components/pages/careersForm")
    },
    {
      path: "/regularBooking",
      name: "Regular Booking",
      component: () => import("@/components/pages/regularBooking")
    },
    {
      path: "/paynow/:transaction_id",
      name: "Pay Now",
      component: () => import("@/components/pages/payNow")
    },
    // STATIC PAGES START
    {
      path: "/about-us",
      name: "About Us",
      component: aboutUs
    },
    {
      path: "/contact-us",
      name: "Contact Us",
      component: contactUs
    },
    {
      path: "/investors",
      name: "Investors",
      component: investors
    },
    {
      path: "/privacy-policy",
      name: "Privacy Policy",
      component: () => import("@/components/pages/privacyPolicy")
    },
    {
      path: "/terms-and-conditions",
      name: "Terms and Conditions",
      component: termsAndConditions
    },
    {
      path: "/refunds-and-cancellation",
      name: "Refunds And Cancellation",
      component: refundsAndCancellation
    },
    {
      path: "/safety",
      name: "Safety Precautions",
      component: () => import("@/components/pages/safety")
    },
    {
      path: "/careers",
      name: "Careers",
      meta: {
        title: "Careers"
      },
      component: LifeMirajCinemas 
    },
    {
      path: "/404",
      name: "404 Page",
      component: page404
    },
    {
      path: "*",
      name: "404 Page",
      component: page404
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js